import { ButtonStyled, ButtonSuccessStyled, ContainerCardBalanceStyled, ContentBodyStyled, ContentInfoBalanceStyled, ContentSuccessStyled, Description, DividerButtonsStyled, Icon, TextContainer, TextSuccessStyled, Title, TotalAvailableStyled } from "./style-component";
import { DividerStyled} from "../../style-component";
import { ObjectiveBenefitProps } from "./objective-benefit-type";
import FormattedImage from '@/components/formatted-image/formatted-image';
import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "@/contexts/user/useUserContext";
import useMissionExchange from "./hook/useMissionExchange";
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Objective } from "@/types/objective/objective-type";
import { ExchangeClaimBodyType } from "@/types/campaign/exchange-claim/exchange-claim";
import { Campaign } from "@/types/campaign/campaign-type";
import ExpiredMission from "@/components/expired-mission/expired-mission";
import brandData from "@/assets/brand.json"
import TPremiaCard from "@/components/t-premia-card/t-premia-card";


const CardBalance: React.FC<{ title: string, description: string }> = ({ title, description, ...props }) => {
  return (
    <ContainerCardBalanceStyled {...props}>
      <Icon
        as={FormattedImage}
        webpSrc={brandData.pages.wallet.currencies[0].icon}
        fallbackSrc={brandData.pages.wallet.currencies[0].iconFallback}
        alt={brandData?.pages?.wallet?.currencies?.[0]?.title}
        style={{
          margin: '0px',
        }}
      />
      <TextContainer>
        <Title data-testid="title-balance">{title}</Title>
        <Description data-testid="description-balance">{description}</Description>
      </TextContainer>
    </ContainerCardBalanceStyled>
  )
}

interface RenderChildrenProps {
  campaign: Campaign;
  objective: Objective;
  disabled: boolean;
  handleSendGift: (body: ExchangeClaimBodyType) => Promise<void>;
  getTotalAfterBuyOfFriend: (price: number) => void;
  position: number;
}

const RenderChildren: React.FC<RenderChildrenProps> = ({ campaign,objective, disabled, handleSendGift, getTotalAfterBuyOfFriend, position }) => {
  const { quantity } = objective;
  const priceBenefit = objective?.quantity ?? 0;
  const disableButtonBuyOfFriend = disabled || priceBenefit <= 0;
  const [loadingBuy, setLoadingBuy] = useState<boolean>(false);

  const handleBuy = useCallback(async () => {
    try {
      setLoadingBuy(true);
      await handleSendGift({
          campaign_id: campaign.id,
          mission_id: objective.mission_id,
          objective_id: objective.id
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingBuy(false);
    }
  }, [handleSendGift, campaign, objective]);

  useEffect(() => {
    if(position === 0) {
      getTotalAfterBuyOfFriend(priceBenefit);
    }
  }, [position, priceBenefit, getTotalAfterBuyOfFriend]);

  if(loadingBuy) {
    return (
      <center>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} size="small" />
      </center>
    )
  }

  return (
    <ButtonStyled
      variant="solid"
      color="white"
      className="custom-button"
      disabled={disableButtonBuyOfFriend}
      data-testid="button-buy-friend"
      onClick={handleBuy}
    >
      Regalar a un amigo por {quantity} <span>
        <Icon
          as={FormattedImage}
          webpSrc={brandData.pages.wallet.currencies[0].icon}
          fallbackSrc={brandData.pages.wallet.currencies[0].iconFallback}
          alt={brandData?.pages?.wallet?.currencies?.[0]?.title}
          style={{
            width: '16px',
            height: '16px',
            margin: '0px'
          }}
        />
      </span>
    </ButtonStyled>
  )
}

const RenderBenefitObjective: React.FC<ObjectiveBenefitProps> = ({
  isExpiredMission,
  isComingSoon,
  mission,
  campaign,
  objective,
  isCompleted,
  loadingProgress,
	getProgress
}) => {
  const {  children } = objective;
  //const valuesOfType = type.split(':');
  //const exchangeContract = valuesOfType[1]?.split('_')[0] ?? ''; //v enviar como body
  //const currencyAddress = valuesOfType[2]?.split('_')[0] ?? ''; // token address RC20 , para validar el balance del usuario
  const navigate = useNavigate();
  const { user, isConnect } = useUserContext();
  const { availablePieces, loadingBuy, setLoadingBuy, loadingBenefitAvailable, success, handleBuy, handleGo } = useMissionExchange(objective, campaign);
  const priceBenefit = objective?.quantity ?? 0;
  const haveSufficientBalance = Boolean(user?.balance && user?.balance > 0 && user?.balance >= priceBenefit);
  const disableButtonBuyOfMe = isCompleted || isExpiredMission || !haveSufficientBalance || availablePieces <= 0 || loadingBuy;
  const disableButtonBuyOfFriend = isExpiredMission || !haveSufficientBalance || availablePieces <= 0 || loadingBuy;
  const includeValidChildren = children?.length > 0 && children?.every(child => child.type?.split(':')[0] === 'EXCHANGE_SHARE');
  const [totalAfterBuyOfFriend, setTotalAfterBuyOfFriend] = useState<number>(0);
  const completedClaim = success || isCompleted;

  const getTotalAfterBuyOfMe = useCallback(() => {
    if(!user?.balance || user?.balance <= priceBenefit) {
      return 0;
    }
    return user?.balance - priceBenefit;
  }, [user, priceBenefit]);

  const getTotalAfterBuyOfFriend = useCallback((price: number) => {
    if(user?.balance === undefined || user?.balance <= price) {
      setTotalAfterBuyOfFriend(0);
    }
    setTotalAfterBuyOfFriend((user?.balance ?? 0) - price);
  }, [user]);

  const handleBuyOfMe = useCallback(async () => {
    try {
      setLoadingBuy(true);
      await handleBuy({
        campaign_id: campaign.id,
        mission_id: objective.mission_id,
        objective_id: objective.id
      });
      await getProgress();
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingBuy(false);
    }
  }, [handleBuy, getProgress, campaign, objective, setLoadingBuy]);

  const handleButAndSendGift = useCallback(async (body: ExchangeClaimBodyType) => {
    const id = mission?.benefits?.[0]?.reward?.id;
    if(!id) {
      return ;
    }
    try {
      await handleBuy(body);
      navigate(`/send-gift/${id}`)
    } catch (error) {
      console.error(error);
    }
  }, [navigate, mission, handleBuy]);


  return (
    <ContentBodyStyled>
      <TPremiaCard variant="dark" style={{ padding: '0px', width: 'fit-content', margin: '0 auto' }}>
      <TotalAvailableStyled>
        <p>Quedan <span>{loadingBenefitAvailable ? <Spin style={{margin: '0px 3px'}} indicator={<LoadingOutlined style={{ fontSize: 10 }} spin />} size="small" /> : availablePieces} unidades</span> disponibles de este beneficio</p>
      </TotalAvailableStyled>
      </TPremiaCard>
      <ContentSuccessStyled>
        {loadingBuy && (
          <center>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} size="small" />
          </center>
        )}
        {!loadingBuy && completedClaim && (
          <TextSuccessStyled>
            ¡Redimido exitosamente! <span><CheckCircleOutlined /></span>
          </TextSuccessStyled>
        )}
        {!loadingBuy && completedClaim  && (
        <ButtonSuccessStyled 
          onClick={() => handleGo('/wallet')}
        >
          ¡Ya lo tienes! Ver en mi wallet
        </ButtonSuccessStyled>
        )}
        {!loadingBuy && !completedClaim && (
          <ButtonStyled
            data-testid="button-buy"
            variant="solid"
            color="primary"
            className="custom-button"
            disabled={loadingProgress || disableButtonBuyOfMe || isComingSoon}
            onClick={handleBuyOfMe}
          >
            Obtener por {priceBenefit} <span>
              <Icon
                as={FormattedImage}
                webpSrc={brandData.pages.wallet.currencies[0].icon}
                fallbackSrc={brandData.pages.wallet.currencies[0].iconFallback}
                alt={brandData?.pages?.wallet?.currencies?.[0]?.title}
                style={{
                  width: '16px',
                  height: '16px',
                  margin: '0px',
                }}
              />
            </span>
          </ButtonStyled>
        )}
        {includeValidChildren && <DividerButtonsStyled type="horizontal">o</DividerButtonsStyled>}
        {includeValidChildren && children?.map((child, position) => (
          <RenderChildren 
            key={child?.id || position}
            campaign={campaign}
            objective={child}
            disabled={disableButtonBuyOfFriend || isComingSoon}
            handleSendGift={handleButAndSendGift}
            getTotalAfterBuyOfFriend={getTotalAfterBuyOfFriend}
            position={position}
          />
        ))}
      </ContentSuccessStyled>
      {isConnect && (!success || includeValidChildren) && <ContentInfoBalanceStyled>
        <CardBalance data-testid="balance-current" title={`Tus ${brandData?.pages?.wallet?.currencies?.[0]?.title} actuales`} description={`${user?.balance} ${brandData?.pages?.wallet?.currencies?.[0]?.title}`}></CardBalance>
        <DividerStyled className="divider" />
        <CardBalance data-testid="balance-after-exchange" title="Después del canje" description={`${!loadingBuy && completedClaim ? totalAfterBuyOfFriend : getTotalAfterBuyOfMe()} ${brandData?.pages?.wallet?.currencies?.[0]?.title}`}></CardBalance>
      </ContentInfoBalanceStyled>
      }
    </ContentBodyStyled>
  )
}

const ObjectiveBenefit: React.FC<ObjectiveBenefitProps> = ({
  campaign,
  objective,
  mission,
  isComingSoon,
  isExpiredMission,
  isCompleted,
  loadingProgress,
	getProgress
}) => {
  const { children } = objective;
  
	if (!isCompleted && isExpiredMission && children?.length === 0) {
		return (
			<ExpiredMission />
		)
	}

  return (
    <RenderBenefitObjective 
      isExpiredMission={isExpiredMission}
      isComingSoon={isComingSoon}
      mission={mission}
      campaign={campaign}
      objective={objective}
      isCompleted={isCompleted}
      loadingProgress={loadingProgress}
      getProgress={getProgress}
    />
  )


}

export default ObjectiveBenefit;
